import { render } from "./warehouse-modal.vue?vue&type=template&id=e4f0df36"
import script from "./warehouse-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__